<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";
import { MSG_TYPE } from "../components/error/errorConstants";

export default {
  name: "ShopRootPage",
  components: {},
  created() {
    console.log(`[ShopRootPage] url(current)`, this.$route.path);

    // shopId 保存
    const shopId = this.$route.params.shopId;
    console.log(`shopId`, shopId);
    this.$store.commit("shopId", shopId);

    // progress (これを閉じるとチラチラするので show させたまま -> 各ページで hide する)
    this.showProgress();
  },
  computed: {
    ...mapGetters(["debug", "progress", "allowPc"]),
  },
  mounted: async function () {
    console.log("[ShopRootPage] mounted");

    // 設定読込 (liff 以外のページで DB 使うので必須)
    try {
      await this.loadSettings();
    } catch (e) {
      // エラーページ (読込失敗)
      this.hideProgress();
      this.$router
        .push({ name: "Error", query: { msgType: MSG_TYPE.LOAD } })
        .catch(() => {});
      return;
    }

    // PC許可サイトは liff 初期化不要
    if (this.allowPc) {
      // console.log("allowPc");
      this.hideProgress();
      return;
    }

    //TODO デバッグ判定 (liffMock 使って isInClient 実装する)
    // LIFF 以外はエラーページ遷移 (デバッグ時は無条件に通す)
    if (!this.debug && !liff.isInClient()) {
      // エラーページ (読込失敗)
      this.hideProgress();
      this.$router.push({ name: "NotFoundError" });
      return;
    }

    // liffId 取得
    const liffId = await this.getLiffId();
    if (!liffId) {
      // エラーページ
      this.hideProgress();
      this.$router
        .push({ name: "Error", query: { msgType: MSG_TYPE.LOAD } })
        .catch(() => {});
      return;
    }
    console.log("liffId", liffId);

    // LIFF 初期化
    console.log("[ShopRootPage] liff#init start");
    liff.init({ liffId: liffId }).then(() => {
      console.log("[ShopRootPage] liff#init end");
    });
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress"]),
    ...mapActions("rest", ["getLiffId"]),
    ...mapActions("settings", ["loadSettings"]),
  },
};
</script>
